import Option from '../../components/Option'
import { OptionButton } from '../../components/common/OptionButton'

export type LineHeightUpdater = (value: number) => void

type SpacingProps = {
  lineHeight?: number
  update: LineHeightUpdater
}

function Spacing({ lineHeight, update }: SpacingProps) {
  return (
    <Option label="settings_options.spacing.label">
      <div className="flex">
        <OptionButton selected={lineHeight === 1.3} onClick={() => update(1.3)}>
          <span className="fas fa-align-justify" />
        </OptionButton>
        <OptionButton selected={lineHeight === 1.6} onClick={() => update(1.6)}>
          <span className="fas fa-align-justify" />
        </OptionButton>
        <OptionButton selected={lineHeight === 1.9} onClick={() => update(1.9)}>
          <span className="fas fa-align-justify" />
        </OptionButton>
        <OptionButton selected={lineHeight === 2.2} onClick={() => update(2.2)}>
          <span className="fas fa-align-justify" />
        </OptionButton>
      </div>
    </Option>
  )
}

export default Spacing
